export default __webpack_public_path__ + "static/Tek_Grenade-88c12716040585be02b1eab6aa0b1646.png";